export default "__VITE_PUBLIC_ASSET__a7896c99__"